import React, { useState, useEffect, useContext } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom';
import "../styles/AddOrganization.css"
import { OrganizationContext } from '../contexts/OrganizationContext';
// import {provinces } from '../assets/data';

const normalizeOptions = (list = []) =>
    (Array.isArray(list) ? list : [])
        .sort((a, b) => (a?.SortOrder ?? 0) - (b?.SortOrder ?? 0))
        .map((item) => {
            const value =
                item?.Value ??
                item?.value ??
                item?.Name ??
                item?.name;

            const label =
                item?.Label ??
                item?.label ??
                item?.Name ??
                item?.name ??
                value;

            return {
                value,
                label,
            };
        });

//This Add organization modal controls the signing up of an organization in our organizations table
export const AddOrganization = (props) => {
    const navigate = useNavigate();
    const { 
        organization,
        updateOrganizationField,
        addOrganization,
        onImageChange,
        validationErrors,
    } = useContext(OrganizationContext);

    const [organizationTypes, setOrganizationTypes] = useState([]);
    const [organizationTiers, setOrganizationTiers] = useState([]);
    const [organizationDenominations, setOrganizationDenominations] = useState([]);
    const [countries, setCountries] = useState([]);
    const [provinces, setProvinces] = useState([]);
    const [paymentTerms, setPaymentTerms] = useState([]);

    useEffect(() => {

        const fetchDropdownData = async () => {
            try {
                const apiUrl =
                    process.env.REACT_APP_API_URL + "/master-data/organiation-fields";

                const response = await fetch(apiUrl, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: process.env.REACT_APP_API_AUTHORIZATION,
                        Accept: "application/json",
                    },
                });

                const data = await response.json();

                if (!response.ok) {
                    throw new Error(data.message || "Failed to fetch dropdown data");
                }

                const organizationTypes = normalizeOptions(data?.data?.OrganizationType);
                const organizationDenominations = normalizeOptions(data?.data?.OrganizationDenomination);
                const organizationTiers = normalizeOptions(data?.data?.OrganizationTier);
                const countries = normalizeOptions(data?.data?.Country);
                const provinces = data?.data?.Province;
                const paymentTerms = normalizeOptions(data?.data?.PaymentTerm);

                setOrganizationTypes(organizationTypes);
                setOrganizationDenominations(organizationDenominations);
                setOrganizationTiers(organizationTiers);
                setCountries(countries);    
                setProvinces(provinces);    
                setPaymentTerms(paymentTerms);

            } catch (err) {
                console.error(err);

                const fallback = [{ value: "", label: "---No Records---" }];
                setOrganizationTypes(fallback);
                setOrganizationDenominations(fallback);
                setOrganizationTiers(fallback);
                setCountries(fallback);
                setProvinces(fallback);
                setPaymentTerms(fallback);
            }
        };

        fetchDropdownData();
    }, []);
    return (
        <>
          <Modal show={props.show} onHide={props.onHide} dialogClassName="modal-90w">
            <Modal.Header closeButton>
              <Modal.Title> Add New Organization</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ChurchImage className='mx-5 p-0'>
                    <input type="file" onChange={onImageChange} accept="image/png" id="png-upload" className="filetype" style={{display: "none"}} />
                    <label htmlFor="png-upload">
                        <img   
                            src={organization.image ? URL.createObjectURL(organization.image) : require("../assets/images/churchIcon.png")} 
                            alt="logo" width={'146'}
                        />
                        
                    </label>
                </ChurchImage>
    
                <ChurchInfo className='p-3'>
                    <ChurchInfoHeader className='p-2'>
                        Organization Info
                    </ChurchInfoHeader>
                   
                    <div className="row form-group mb-2 p-2">
                        <div className="col">
                            <label htmlFor="organizationName"><h6> Name<sup>*</sup> </h6></label>
                            <input type="text" className="form-control" id="organizationName" onChange={(e) => updateOrganizationField('name', e.target.value)} value={organization.name} />
                        </div>
        
                        <div className="col">
                            <label htmlFor="organizationType"><h6> Type<sup>*</sup> </h6></label>
                            <select className="form-control"
                            value={organization.type}
                            onChange={(e)=> updateOrganizationField('type', e.target.value)}
                                >
                                <option default value="">Select Type </option>
                                {organizationTypes.map(type => (
                                    <option key={type.id} value={type.value}>{type.label}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="row form-group mb-2 p-2">
                        <div className="col">
                            <label htmlFor="organizationDenomination"><h6> Denomination </h6></label>
                            <select className="form-control"
                            value={organization.denomination}
                            onChange={(e)=> updateOrganizationField('denomination', e.target.value)}
                                >
                                <option default value="">Select Denomination Type </option>
                                {organizationDenominations.map(denom => (
                                    <option key={denom.id} value={denom.value}>{denom.label}</option>
                                ))}
                            </select>
                        </div>

                        <div className="col">
                            <div className="form-check mb-3 pt-2">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="is_sponsored"
                                    checked={!!organization.is_sponsored}
                                    onChange={(e) => {
                                        const checked = e.target.checked;
                                        updateOrganizationField('is_sponsored', checked);
                                        if (checked) {
                                            updateOrganizationField('stripeId', '');
                                        }
                                    }}
                                />
                                <label className="form-check-label" htmlFor="is_sponsored">
                                    <h6 className="d-inline mb-0">Sponsored organization</h6>
                                </label>
                            </div>
                            {!organization.is_sponsored && (
                                <>
                                    <label htmlFor="stripeId"><h6> Stripe ID</h6></label>
                                    <input type="text" className="form-control" id="stripeId" onChange={(e) => updateOrganizationField('stripeId', e.target.value)} value={organization.stripeId} />
                                </>
                            )}
                        </div>
                    </div>

                    <div className="row form-group mb-2 p-2">
                        <div className="col">
                            <label htmlFor="zohoAccountId"><h6> Zoho Account ID<sup>*</sup></h6></label>
                            <input type="text" className="form-control" id="zohoAccountId" onChange={(e) => updateOrganizationField('zohoAccountId', e.target.value)} value={organization.zohoAccountId ?? ""} />
                        </div>
                    </div>

                    <div className="row form-group mb-2 p-2">
                        <div className="col">
                            <label htmlFor="organizationType"><h6>Tier<sup>*</sup> </h6></label>
                            <select className="form-control"
                            value={organization.tier}
                            onChange={(e)=> updateOrganizationField('tier', e.target.value)}
                                >
                                <option default value="">Select Tier </option>
                                {organizationTiers.map(tier => (
                                    <option key={tier.id} value={tier.value}>{tier.label}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col">
                            <label htmlFor="organizationName"><h6>Payment Term<sup>*</sup> </h6></label>
                            <select className="form-control"
                            value={organization.paymentTerm}
                            onChange={(e)=> updateOrganizationField('paymentTerm', e.target.value)}
                                >
                                    <option default value="">Select Payment Term </option>
                                    {paymentTerms.map(term => (
                                        <option key={term.id} value={term.value}>{term.label}</option>
                                    ))}
                            </select>
                        </div>
        
                        
                    </div>

                    <div className="row form-group mb-2 p-2">
                    <div className="col">
                        <label htmlFor="address"><h6>Address<sup>*</sup> </h6></label>
                        <input type="text" className={`form-control ${validationErrors.address ? "is-invalid" : ""}`} id="address" placeholder="123 Main Street" value={organization.address}
                            onChange={(e)=> updateOrganizationField('address', e.target.value)} />
                        {validationErrors.address && <div className="invalid-feedback">{validationErrors.address}</div>}
                    </div>
                    </div>
                    <div className="row form-group mb-2 p-2">
                    <div className="col">
                        <label htmlFor="city"><h6>City<sup>*</sup> </h6> </label>
                        <input type="text" className="form-control" id="city" value={organization.city} 
                            onChange={(e)=> updateOrganizationField('city', e.target.value)}
                        />
                    </div>
                    <div className="col">
                        <label htmlFor="country"><h6>Country<sup>*</sup> </h6></label>
                        <select 
                            className="form-control"
                            value={organization.country}
                            onChange={(e) => {
                                updateOrganizationField('country', e.target.value);
                                updateOrganizationField('province', ''); // Reset province when country changes
                            }}
                        >
                            <option default value="">Select Country</option>
                            {countries.map(country => (
                                <option key={country.id} value={country.value}>{country.label}</option>
                            ))}
                        </select>
                    </div>
                    </div>
                    <div className="row form-group mb-2 p-2">
                    <div className="col">
                        <label htmlFor="province"><h6>Province / State<sup>*</sup> </h6></label>
                        <select 
                            className="form-control"
                            value={organization.province}
                            onChange={(e) => updateOrganizationField('province', e.target.value)}
                            disabled={!organization.country}
                        >
                            <option default value="">Select Province/State</option>
                            {organization.country && provinces[organization.country] && 
                                provinces[organization.country].map(province => (
                                    <option key={province.id} value={province.value}>
                                        {province.label}
                                    </option>
                                ))
                            }
                        </select>
                    </div>
                    <div className="col">
                        <label htmlFor="postalCode"><h6>ZIP / Postal Code<sup>*</sup> </h6></label>
                        <input type="text" className={`form-control ${validationErrors.postalCode ? "is-invalid" : ""}`} id="postalCode" placeholder="A1A 1A1 or 12345" 
                            value={organization.postalCode} 
                            onChange={(e)=> updateOrganizationField('postalCode', e.target.value)}
                        />
                        {validationErrors.postalCode && <div className="invalid-feedback">{validationErrors.postalCode}</div>}
                    </div>
                    </div>
                    <div className="row form-group mb-2 p-2">
                    <div className="col">
                        <label htmlFor="website"><h6>Website</h6></label>
                        <input type="url" className={`form-control ${validationErrors.website ? "is-invalid" : ""}`} id="website" placeholder="https://example.com" 
                            value={organization.website} 
                            onChange={(e)=> updateOrganizationField('website', e.target.value)}
                        />
                        {validationErrors.website && <div className="invalid-feedback">{validationErrors.website}</div>}
                    </div>
                    
                    <div className="col">
                        <label htmlFor="prayerlineUrl"><h6>Prayerline URL</h6></label>
                        <input type="url" className={`form-control ${validationErrors.prayerlineUrl ? "is-invalid" : ""}`} id="prayerlineUrl" placeholder="https://example.com/prayerline"  
                            value={organization.prayerlineUrl} 
                            onChange={(e)=> updateOrganizationField('prayerlineUrl', e.target.value)}
                        />
                        {validationErrors.prayerlineUrl && <div className="invalid-feedback">{validationErrors.prayerlineUrl}</div>}
                    </div>
                    </div>
                    <div className="row form-group mb-2 p-2">
                    <div className="col">
                        <label htmlFor="organizationPhoneNumber"><h6>Phone Number<sup>*</sup></h6></label>
                        <input type="tel" className={`form-control ${validationErrors.organizationPhoneNumber ? "is-invalid" : ""}`} id="organizationPhoneNumber" placeholder="+1 (555) 555-5555"  
                            value={organization.organizationPhoneNumber} 
                            onChange={(e)=> updateOrganizationField('organizationPhoneNumber', e.target.value)}
                        />
                        {validationErrors.organizationPhoneNumber && <div className="invalid-feedback">{validationErrors.organizationPhoneNumber}</div>}
                    </div>
                    </div>
                </ChurchInfo>
    
                <PastorInfo className='p-3'>
                    <PastorInfoHeader className='p-2'>
                       Lead Pastor Info
                    </PastorInfoHeader>              
                    {/* <div className="row form-group mb-2 p-2">
                    <div className="col">
                        <label htmlFor="leadPastorName"><h6>Manager Full Name<sup>*</sup></h6></label>
                        <input type="text" className="form-control" id="leadPastorName"  
                            value={leadPastorName} 
                            onChange={(e)=> setLeadPastorName(e.target.value)}
                        />
                    </div>
                    </div> */}
                    <div className="row form-group mb-2 p-2">
                        <div className="col">
                            <label htmlFor="carePersonName"><h6>Full Name<sup>*</sup></h6></label>
                            <input type="text" className="form-control" id="carePersonName" 
                                value={organization.carePersonName} 
                                onChange={(e)=> updateOrganizationField('carePersonName', e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="row form-group mb-2 p-2">
                        <div className="col">
                            <label htmlFor="carePersonEmail"><h6>Email<sup>*</sup> </h6></label>
                            <input type="email" className={`form-control ${validationErrors.carePersonEmail ? "is-invalid" : ""}`} id="carePersonEmail" placeholder="name@example.com"
                                value={organization.carePersonEmail} 
                                onChange={(e)=> updateOrganizationField('carePersonEmail', e.target.value)}
                            />
                            {validationErrors.carePersonEmail && <div className="invalid-feedback">{validationErrors.carePersonEmail}</div>}
                        </div>
                    </div>
                    <div className="row form-group mb-2 p-2">
                        <div className="col">
                            <label htmlFor="carePersonPhone"><h6>Phone<sup>*</sup></h6></label>
                            <input type="tel" className={`form-control ${validationErrors.carePersonPhone ? "is-invalid" : ""}`} id="carePersonPhone" placeholder="+1 (555) 555-5555 ext. 123" 
                                value={organization.carePersonPhone} 
                                onChange={(e)=> updateOrganizationField('carePersonPhone', e.target.value)}
                            />
                            {validationErrors.carePersonPhone && <div className="invalid-feedback">{validationErrors.carePersonPhone}</div>}
                        </div>
                    </div>
                </PastorInfo>
    
                <MoreInfo className='p-3'>
                    <MoreInfoHeader className='p-2'>
                        More Info
                    </MoreInfoHeader>  
                    <div className="row form-group mb-2 p-2">
                        <div className="col">
                            <label htmlFor="assignedNumber"><h6>Assigned Number</h6></label>
                            <input type="text" className="form-control" id="assignedNumber" 
                                value={organization.assignedNumber} 
                                onChange={(e)=> updateOrganizationField('assignedNumber', e.target.value)}
                            />
                        </div>
                        <div className="col">
                            <label htmlFor="prayerPartnersCount"><h6>Prayer Partners Count</h6></label>
                            <input type="text" className="form-control" id="prayerPartnersCount" 
                                value={organization.prayerPartnersCount} 
                                onChange={(e)=> updateOrganizationField('prayerPartnersCount', e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="row form-group mb-2 p-2">
                        <div className="col">
                            <label htmlFor="serviceStartTimes"><h6>Sunday Service Start Times</h6></label>
                            <input type="text" className={`form-control ${validationErrors.serviceStartTimes ? "is-invalid" : ""}`} id="serviceStartTimes" maxLength={4000} placeholder="e.g. Sundays at 10:00 AM" 
                                value={organization.serviceStartTimes} 
                                onChange={(e)=> updateOrganizationField('serviceStartTimes', e.target.value)}
                            />
                            {validationErrors.serviceStartTimes && <div className="invalid-feedback">{validationErrors.serviceStartTimes}</div>}
                        </div>
                    </div>
                    <div className="row form-group mb-2 p-2">
                        <div className="col">
                            <label htmlFor="churchPrograms"><h6>Church Programs</h6></label>
                            <input type="text" className={`form-control ${validationErrors.churchPrograms ? "is-invalid" : ""}`} id="churchPrograms" maxLength={4000} placeholder="Describe church programs" 
                                value={organization.churchPrograms} 
                                onChange={(e)=> updateOrganizationField('churchPrograms', e.target.value)}
                            />
                            {validationErrors.churchPrograms && <div className="invalid-feedback">{validationErrors.churchPrograms}</div>}
                        </div>
                    </div>
                    <div className="row form-group mb-2 p-2">
                        <div className="col">
                            <label htmlFor="prayerlineUrl"><h6>Prayer line landing page</h6></label>
                            <input type="url" className={`form-control ${validationErrors.prayerlineUrl ? "is-invalid" : ""}`} id="prayerlineUrl" placeholder="https://example.com/landing-page" 
                                value={organization.prayerlineUrl} 
                                onChange={(e)=> updateOrganizationField('prayerlineUrl', e.target.value)}
                            />
                            {validationErrors.prayerlineUrl && <div className="invalid-feedback">{validationErrors.prayerlineUrl}</div>}
                        </div>
                    </div>
                    <div className="row form-group mb-2 p-2">
                        <div className="col">
                            <label htmlFor="description"><h6>Subscriber Description</h6></label>
                            <textarea className={`form-control ${validationErrors.description ? "is-invalid" : ""}`} id="description" maxLength={4000} placeholder="Describe the organization" 
                                value={organization.description} 
                                onChange={(e)=> updateOrganizationField('description', e.target.value)}
                            />
                            {validationErrors.description && <div className="invalid-feedback">{validationErrors.description}</div>}
                        </div>
                    </div>
                </MoreInfo>
              
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={props.onHide}>
                Close
              </Button>
              <Button
                variant="primary"
                        onClick={() => addOrganization(props.setShow, () => navigate("/subscribers"))}
              >
                Add Organization
              </Button>
            </Modal.Footer>
          </Modal>
        </>
    );
}


const ChurchImage = styled.div`
    border: 1px dotted black;
    border-radius: 20px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    img{
        cursor: pointer;
    }
`;

const ChurchInfo = styled.div`

`;
const MoreInfo = styled.div`
    background-color: #FFEAE4;
    input{
        background-color: #FFEAE4;
    }
`;

const MoreInfoHeader = styled.h4`
    text-align: left;
    color: #EC3310;
    font-family: Recoleta;
    text-decoration: underline;
`;

const PastorInfo = styled.div`
    background-color: #f3f9fa;
    input{
        background-color: #f3f9fa;
    }
`;

const PastorInfoHeader = styled.h4`
    text-align: left;
    color: #2DB3C0;
    font-family: Recoleta;
    text-decoration: underline;
`;

const ChurchInfoHeader = styled.h4`
text-align: left;

    color: #FF7234;
    font-family: Recoleta;
    text-decoration: underline;
`;